import { NotifsLayer } from '@/containers';
import { NotifsContextProvider } from '@/contexts';
import { InactivityProvider } from '@/contexts/InactivityContext';
import useBrand from '@/hooks/useBrand';
import { Brand } from '@/types/Brand';

export function generateStaticParams() {
  return Object.values(Brand).map((brand) => {
    return {
      brand,
    };
  });
}

export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  const brand: Brand = useBrand().get() ?? Brand.CETELEM;

  return (
    <InactivityProvider
      excludePaths={['login', 'logout', 'callback']}
      brand={brand}
    >
      <NotifsContextProvider>
        <NotifsLayer>{children}</NotifsLayer>
      </NotifsContextProvider>
    </InactivityProvider>
  );
}
